import React from "react";

import Container from "../shared/container";

import { __t } from "../../utils/translate";
import { Product } from "../../utils/types";

import Faq from "./faq";
import SizeChart from "./sizeChart";

type FigmaDesignProps = {
    product: Product;
};

const FigmaDesign: React.FC<FigmaDesignProps> = ({
    product,
}) => {
    return (
        <div className="w-full bg-white mt-[30px]" id="productFigmaDescription">
            {!product.acf.video && (
                <div className="max-w-[1152px] mx-auto px-5 md:px-[30px] lg:px-7 xl:px-0 ">
                    <p className={`text-center text-h2-r md:text-h2 text-main-text-color lg:text-black w-full pt-[30px] pb-6 lg:pb-8`}>
                        {product.acf.first_header}
                    </p>
                </div>
            )}
            <div className="w-full bg-light-blue xl:bg-white">
                <div className="max-w-[1152px] mx-auto  xl:bg-light-blue">
                    <div className={`${!!product.acf.video ? 'md:min-h-[610px] py-8 px-[15px] md:pl-[50px] md:pr-[40px]' : 'py-[50px] md:py-[63px] px-8'} flex flex-col-reverse md:flex-row items-start mx-auto gap-7 md:gap-[90px] xl:gap-35 md:py-[63px]`}>

                        <div className="w-full h-full my-auto text-center md:text-start">
                            {!!product.acf.video && (
                                <p className={`md:block hidden mb-[30px] text-price md:text-h2 text-main-text-color lg:text-black w-full px-[10px] md:px-0`}>
                                    {product.acf.first_header}
                                </p>
                            )}
                            <p className={`${product.acf.video === '' ? 'font-bold md:font-normal text-dark' : 'md:!leading-7 text-[#405465]'} text-base-16 !leading-[1.6] lg:text-h3-r  `}>
                                {product.acf.first_description_block}
                            </p>
                        </div>
                        {!!product.acf.video && (
                            <div className="w-full my-auto overflow-hidden">
                                <div className="w-fit pb-0 " dangerouslySetInnerHTML={{ __html: product.acf.video }}></div>
                            </div>
                        )}
                        {!!product.acf.video && (
                            <p className={`md:hidden text-center text-price lg:text-h2 text-main-text-color lg:text-black w-full px-[10px]`}>
                                {product.acf.first_header}
                            </p>
                        )}
                    </div>
                </div>
            </div>
            {!!product.acf.adventures_group?.length && (
                <Container>
                    <div className="flex flex-col md:flex-row text-center justify-center gap-3 px-5 py-[64px] md:pb-[74px] md:px-4">
                        {product.acf.adventures_group.map((adventure: any, index) => {
                            return (
                                <div key={index} className="flex flex-col items-center border border-[#b6c5d1] p-[15px] w-full md:w-[33%] md:max-w-[355px]">
                                    <img className="mb-[2px] w-20 md:w-[120px]" width='120' height='120' src={adventure.image.url} loading="lazy" alt={adventure.image.alt ? adventure.image.alt : ''}></img>
                                    <h2 className="text-base-16 md:text-[22px] xl:text-[24px] text-main-text-color uppercase mb-3">{adventure.header}</h2>
                                    <p className="text-base-16 text-body-text-color">{adventure.text}</p>
                                </div>
                            );
                        })
                        }
                    </div>
                </Container>
            )}

            {!!product.acf.description_group?.length && (
                <div className="w-full bg-background-color md:bg-light-blue xl:bg-white">
                    <Container className="lg:!px-0">
                        <div className="max-w-[1152px] mx-auto w-full flex flex-col items-center pt-5 mb-5 md:mb-1 md:py-[56px] md:px-4 lg:px-8 xl:bg-light-blue">
                            {product.acf.description_group.map((description: any, index) => {
                                return (
                                    <div key={index} className={`md:flex max-w-[1280px] items-center justify-between overflow-hidden
                                            md:min-h-[304px] xl:min-h-[400px]
                                            ${index % 2 === 1 ? 'md:flex-row' : "md:flex-row-reverse"}`}>

                                        <div className="mb-5 mx-auto md:self-start w-full md:max-w-[544px] md:mb-12 md:w-1/2">
                                            <img className="w-full h-auto md:h-fit object-cover" width='640' height='400' src={description.image.url} loading="lazy" alt={description.image.alt ? description.image.alt : ''}></img>
                                        </div>
                                        <div className={`flex flex-col text-center md:text-start w-full md:w-1/2 ${index % 2 === 1 ? 'md:p-[30px]' : 'md:p-[30px]'}`}>
                                            <h5 className="text-h2-r md:text-h2 text-main-text-color lg:text-black mb-4 sm:mb-5 md:mb-[30px]">{description.header}</h5>
                                            <p className="lg:text-h3-r text-base-16 lg:leading-8 mb-8 md:mb-5">{description.text}</p>
                                        </div>
                                    </div>
                                );
                            })
                            }
                        </div>
                    </Container>
                </div>
            )}

            {!!product.acf.more_reasons_group?.length && (
                <Container>
                    <div className="pt-7 mb-7">
                        <h2 className={`text-center text-h2-r md:text-h2 text-main-text-color w-full pb-5 md:pb-7`}>
                            {product.acf.more_reasons_row_header}
                        </h2>
                        <div className="flex flex-wrap text-center justify-center md:justify-start lg:justify-center lg:flex-nowrap gap-x-2 gap-y-6 md:gap-0 w-full">
                            {product.acf.more_reasons_group.map((reason: any, index) => {
                                return (
                                    <div key={index} className={`flex flex-col items-center w-[48%] md:w-[33%] lg:w-[16%] xl:w-[12%] md:min-w-[170px] px-1 `}>
                                        <img className="w-22 md:w-30" src={reason.image.url} width='88' height='88' loading="lazy" alt={reason.image.alt ? reason.image.alt : ''}></img>
                                        <h3><div className="text-base-16 text-wrap text-dark md:min-h-[52px]" dangerouslySetInnerHTML={{ __html: reason.text }}></div></h3>
                                    </div>
                                );
                            })
                            }
                        </div>
                    </div>
                </Container>
            )}

            <SizeChart
                product={product}
                className='mt-[60px] md:mt-[88px] pb-2 md:max-w-[587px] mx-auto'
            />

            {!!product.acf.specification_header && (
                <div className="w-full">
                    <Container>
                        <div className="py-7 md:py-[88px] md:max-w-[768px] mx-auto">
                            <h3 className="text-h2 text-center text-main-text-color pb-7 sm:pb-10">
                                {product.acf.specification_header}
                            </h3>
                            {product.acf.specification.map((item: any, index) => {
                                const title = (item.title ? item.title : "")
                                const value = (item.value ? item.value : "")
                                return (
                                    <div key={index} className={`flex flex-row w-full items-center justify-between text-small-14 md:text-base-16 leading-6 px-[10px] py-1
                                              border-[1px] border-collapse border-border-color border-b-0 last:border-b-[1px]
                                              ${item.only_title ? "bg-light-blue text-main-text-color leading-6 !font-semibold py-2" : "text-body-text-color"}`}>
                                        <div className="pr-[12px]" dangerouslySetInnerHTML={{ __html: title }}></div>
                                        <div className="text-end" dangerouslySetInnerHTML={{ __html: value }}></div>
                                    </div>
                                );
                            })
                            }
                        </div>
                    </Container>
                </div>
            )}

            <Faq
                faq={product.acf.faq}
            />

        </div>
    );
};

export default FigmaDesign;